import { render } from "./WelcomeSidebar.vue?vue&type=template&id=a79d05fa&scoped=true"
import script from "./WelcomeSidebar.vue?vue&type=script&lang=js"
export * from "./WelcomeSidebar.vue?vue&type=script&lang=js"

import "./WelcomeSidebar.vue?vue&type=style&index=0&id=a79d05fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79d05fa"]])

export default __exports__